module.exports = __webpack_public_path__ + "img/lead-transfers.8c59f7f2.svg";